export default function SalesDashboard() {
  return (
    <div style={{ padding: 20 }}>
      <h2>Sales Dashboard</h2>

      <p style={{ fontSize: "13px" }}>
        Future updates will include Sales analytics,
        scores, targets, reports, and performance tracking.
      </p>
    </div>
  );
}